import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { imageUtils } from './utils/responsiveImageUtils';
import { performanceMonitor } from './services/performanceMonitoringService';

// Global error handler for ResizeObserver loop errors
window.addEventListener('error', (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    // Suppress this specific error as it's harmless and commonly occurs with responsive charts
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
});

// Also handle unhandled promise rejections for ResizeObserver errors
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason && e.reason.message && e.reason.message.includes('ResizeObserver loop')) {
    e.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Initialize performance monitoring
performanceMonitor.initialize();

// Initialize asset optimizations for performance
document.addEventListener('DOMContentLoaded', () => {
  // Preload critical images if any
  const criticalImages = ['/logo192.svg', '/favicon.svg'];
  criticalImages.forEach(src => imageUtils.preloadImage(src).catch(console.warn));
});

// Register service worker for PWA functionality
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
        
        // Check for updates to the service worker
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          if (newWorker) {
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  // New service worker available
                  console.log('New service worker available');
                  // You can show a notification to the user here
                  if (window.confirm('New version available! Reload to update?')) {
                    window.location.reload();
                  }
                } else {
                  // Service worker is now controlling the app
                  console.log('App is now available offline');
                }
              }
            });
          }
        });
      })
      .catch((registrationError) => {
        console.log('SW registration failed: ', registrationError);
      });
  });
} 